<template>
  <v-card class="px-12 d-flex align-center" elevation="14" raised style="height: 65vh; background-color: #111111;">
    <div>
      <v-row class="mb-10 d-flex justify-center">
        <div>
          <h1 class="text-center mb-2" style="color: #ffffff">{{ title }}<v-icon class="ml-3" color="green accent-3" medium>fa-regular fa-trophy</v-icon></h1>
          <h3 class="text-center">{{ subtitle }}</h3>
        </div>
      </v-row>
      <v-row align="center" justify="center">
        <v-col>
          <!-- Already registered to tournament !-->
          <div v-if="enrolled">
            <v-chip color="#00F784" class="justify-center" outlined small text-color="#00F784">You're already registered on ranking!
              <v-icon class="icon ml-2" color="green accent-3" x-small>fa-regular fa-check</v-icon>
            </v-chip>
            <p class="mt-7 text-center" style="color: #989898">Remaining time to start the competition</p>
            <Counter class="justify-center" :end-time="endTime" :text-color="'FFFFFF'" :title-color="'FFFFFF'"/>
          </div>

          <!-- Register to tournament !-->
          <div v-else-if="accounts.length !== 0">
            <p style="color: #989898" class="text-center">Remaining time to start the competition</p>
            <Counter class="justify-center" :end-time="endTime" :text-color="'FFFFFF'" :title-color="'FFFFFF'"/>
            <p class="mt-3" style="color: #989898">Select one of your audited accounts:</p>
            <v-form v-model="valid">
              <v-select v-model="accountSelected" :items="accounts" :rules="accountRule" class="mt-n1 mb-n1"
                        dark item-text="identifier" item-value="id" label="Select a audited account" style="width: 100%" outlined/>
              <v-btn v-if="valid" :disabled="!valid" class="pro-button" style="width: 100%" @click="registerTournament">Register now to the competition</v-btn>
            </v-form>
          </div>

          <!-- Go to pro !-->
          <div v-else>
            <p class="text-center" style="color: #989898">Remaining time to create an Equiti account and register</p>
            <Counter class="justify-center" :end-time="endTime" :text-color="'FFFFFF'" :title-color="'FFFFFF'"/>
            <p class="mt-7 text-center" style="color: #989898">You can be one of the three traders awarded with up to 300 USD.</p>
            <v-btn class="pro-button" style="width: 100%" @click="goTo">Create an Equiti Account Now!</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import Counter from './Counter';
export default {
  name: "TournamentRegister",
  components: {Counter},
  props: {
    title: String,
    subtitle: String,
    endTime: Date,
    accounts: Array,
    enrolled: Boolean,
    goToPath: String,
  },
  data() {
    return {
      valid: false,
      accountSelected: '',
      accountRule: [
        a => !!a || 'Account is mandatory to register',
      ],
    };
  },
  methods: {
    registerTournament() {
      if(this.valid){
        this.$emit('register', this.accountSelected);
      }
    },
    goTo() {
      window.open(this.goToPath);
    },
  }
}
</script>

<style scoped>

</style>
